export const GET_INFO = 'CURRENT_ORGANIZATION_LOAD';
export const GET_INFO_START = `${GET_INFO}_START`;
export const GET_INFO_SUCCESS = `${GET_INFO}_SUCCESS`;
export const GET_INFO_FAIL = `${GET_INFO}_FAIL`;

export const GET_DISCLAIMER = 'GET_DISCLAIMER';
export const GET_DISCLAIMER_SUCCESS = `${GET_DISCLAIMER}_SUCCESS`;
export const GET_DISCLAIMER_FAIL = `${GET_DISCLAIMER}_FAIL`;

export const GET_LOGO_URL = 'GET_LOGO_URL';
export const GET_LOGO_URL_SUCCESS = `${GET_LOGO_URL}_SUCCESS`;
export const GET_LOGO_URL_FAIL = `${GET_LOGO_URL}_FAIL`;

export function getInfo() {
  return {
    type: GET_INFO,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/organization',
      method: 'get',
    },
  };
}

export function getDisclaimer() {
  return {
    type: GET_DISCLAIMER,
    meta: {
      xmWebApp: true,
      uri: '/xmatters/registration/api/disclaimer',
      method: 'get',
    },
  };
}

export function getLogoUrl() {
  return {
    type: GET_LOGO_URL,
    meta: {
      xmWebApp: true,
      uri: '/xmatters/registration/api/logo-url',
      method: 'get',
    },
  };
}
